import { createFileRoute, redirect } from '@tanstack/react-router'

import { getToken } from "@/lib/token/token";
import { checkTwoFactorStateAndRedirect, redirectIfTermsAccepted } from "@/lib/utils";
import { TermsPage } from "@/modules/terms/components/terms-page";

export const Route = createFileRoute('/terms')({
  beforeLoad: (): void => {
    // Top-level route, not nested under _auth, so its guards do not run here — repeat them.
    if (!getToken()) {
      // Carry the stashed destination through the login bounce, as _auth does. Deliberately the
      // inner ?redirect param and not location.href: this route reads window.location, so href is
      // absolute, and an absolute `to` is not honoured — it silently falls back to the dashboard.
      const destination = new URLSearchParams(location.search).get('redirect')

      throw redirect(destination ? { to: '/login', search: { redirect: destination } } : { to: '/login' })
    }

    checkTwoFactorStateAndRedirect()

    // An accepted user must not be able to sit on this page.
    redirectIfTermsAccepted()
  },

  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-[#022D4F]">
      <TermsPage />
    </div>
  )
}
